/*
  Shown when a feature's Supabase table hasn't been created yet.
  Points to the SQL setup file shipped with the project.
*/
export default function MissingTable({
  table,
  file = 'src/backend/sql/admin_schema.sql',
}) {
  return (
    <div className="missing-table">
      <h3>⚙️ Setup needed</h3>
      <p>
        The <code>{table}</code> table doesn't exist in your Supabase project
        yet.
      </p>
      <p>
        Open <strong>Supabase Dashboard → SQL Editor</strong> and run the
        matching section from <code>{file}</code> in this project, then refresh
        this page.
      </p>
    </div>
  );
}
